import { Box, useTheme } from "@mui/material";
import {
  StandardPadding,
  StandardPaddingBottom,
  StandardPaddingTop,
} from "./common.elements";

const Section = (props) => {

    const theme = useTheme();

    if(props.padding === undefined){
        return <Box {...props} color={theme.palette.text.secondary}><StandardPadding>{props.children}</StandardPadding></Box>
    }else if(props.padding === "top"){
        return <Box {...props} color={theme.palette.text.secondary}><StandardPaddingTop>{props.children}</StandardPaddingTop></Box>
    }else if(props.padding === "bottom"){
        return <Box {...props} color={theme.palette.text.secondary}><StandardPaddingBottom>{props.children}</StandardPaddingBottom></Box>
    }else{
        return <Box {...props} color={theme.palette.text.secondary}><StandardPadding>{props.children}</StandardPadding></Box>
    }
};

export default Section;
